import { createContext } from 'react';

export const CookiePolicyContext = createContext({
  isShowCookiePolicyPopup: false,
  close(): void {},
  show(): void {},
  openOneTrustDialog(): void {},
});
